/** A selected automation must never degrade to an empty/partial transaction. */
export const requireWorkflowMessages = <T>(result: T): T => {
  if (
    !result ||
    typeof result !== "object" ||
    !("messages" in result) ||
    !Array.isArray(result.messages) ||
    result.messages.length === 0
  ) {
    throw new Error("Automation is unavailable. No transaction was prepared.");
  }
  return result;
};
